import React from 'react';
import {HouseSelectionDiv} from "./StatisticDesign";
import {LineDiv, Text} from "../go-aroung/design";

const HouseSelection = ({Houses, selectedHouse, setSelectedHouse}) => {

    function changeHouse(event){
        const House=event.currentTarget.id;
        setSelectedHouse(House)
    }
    return (
        <HouseSelectionDiv>
            {
                Houses.map(Element=>{
                    let checked=false
                    if (selectedHouse==Element) checked=true
                    return (
                        <LineDiv key={Element} id={Element} onClick={changeHouse}>
                            <input id={Element} type='checkbox' checked={checked}/>
                            <Text id={Element} >{Element}</Text>
                        </LineDiv>
                    )
                })
            }
        </HouseSelectionDiv>
    );
};

export default HouseSelection;